const buyCheckinKey = (state) => {
  return state.buy.checkin_key
}

const storeListingName = (state) => {
  return state.raiStore.listing_name
}

export default {
  buyCheckinKey,
  storeListingName
}



// WEBPACK FOOTER //
// ./src/store/getters.js